export class Groupe {
  public id: string = "";
  public raisonSociale: string = "";
  // public sites: Site[] = [];
  public raisonsSociales: string[] = new Array();
  public restaurantIds: number[] = new Array();

  public societesPlus: Societe[] = [];
  public societesMoins: Societe[] = [];

  public $edit?: boolean = false;

  constructor(nom?: string) {
    if (nom) {
      this.raisonSociale = nom;
    }
    // this.sites = sites;
  }
}

export class Societe {
  public id: string = "";
  public raisonSociale: string = "";
  public societe0?: boolean = false;
  public restaurantId: number = -1;
  public codeImplant?: string = "";
  public codeLicence?: string = "";

  constructor(nom?: string, restaurantId?: number, codeImplant?: string) {
    if (nom) {
      this.raisonSociale = nom;
    }
    if (restaurantId) {
      this.restaurantId = restaurantId;
    }
    if (codeImplant) {
      this.codeImplant = codeImplant;
    }
  }
}

export class Profil {
  public criteres: string[] = [];
  public droits: string[] = [];
  public id: string = "";
  public raisonsSociales: string[] = [];
  public restaurantIds: number[] = [];
  public societesPlus: Societe[] = [];
  public societesMoins: Societe[] = [];
  public titre: string = "";
  public optionsTickets: string[] = [];
  public profileCaisse: boolean = false;
  public $edit?: boolean = false;
}
